import { createContext } from 'react';
import type { Goal } from '@atlassian/jira-shared-types/src/goal.tsx';

export const GoalFilterContext = createContext<{
	goals: Record<string, Goal>;
}>({ goals: {} });
